var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#D9D9D9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.409 2.386c0-.483-.187-.928-.515-1.27a1.776 1.776 0 0 0-2.516-.012L11.876 18.606l-.831 3.344 3.334-.801L31.881 3.647c.341-.343.528-.79.528-1.26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.864 22.287a1.831 1.831 0 0 1-.872.477l-3.343.805c-.153.033-1.094.161-1.742-.49a1.824 1.824 0 0 1-.483-1.735l.824-3.296c.084-.324.249-.616.495-.86L26.766 1.435a10.31 10.31 0 0 0-4.075-.85H10.307C4.692.586.137 5.092.137 10.645V22.8c0 5.552 4.555 10.059 10.17 10.059H22.69c5.616 0 10.173-4.507 10.173-10.059V10.645c0-1.49-.341-2.888-.918-4.157l-16.07 15.8-.012-.001z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGray);
export default __webpack_public_path__ + "static/media/editGray.b91dc05cec166196b8a1f6d4805a04b1.svg";
export { ForwardRef as ReactComponent };